/**
 * 首页参数API
 *
 * @Author:szs
 * @Date: 2021-09-18
 * @Last Modified time: 2021-09-18
 */

import http from '@/utils/request'
const apis = {
  // 获取参数类型列表
  getHomeParamList(dto) {
    return http.get({
      url: '/pc/sysHomeParam/getHomeParamList',
      data: dto
    })
  },

  // 获取全部参数类型列表
  getHomeParams(dto) {
    return http.get({
      url: '/pc/sysHomeParam/getHomeParams',
      data: dto
    })
  },

  // 获取参数类型
  getHomeParam(dto) {
    return http.get({
      url: '/pc/sysHomeParam/getHomeParam',
      data: dto
    })
  },

  // 保存参数类型
  saveHomeParam(dto) {
    return http.post({
      url: '/pc/sysHomeParam/saveHomeParam',
      data: dto
    })
  },

  // 删除参数类型
  delHomeParam(id) {
    return http.post({
      url: '/pc/sysHomeParam/delHomeParam',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取分组参数列表
  getHomeGroupParamList(dto) {
    return http.get({
      url: '/pc/sysHomeGroupParam/getHomeGroupParamList',
      data: dto
    })
  },

  // 获取分组参数
  getHomeGroupParam(dto) {
    return http.get({
      url: '/pc/sysHomeGroupParam/getHomeGroupParam',
      data: dto
    })
  },

  // 保存分组参数
  saveHomeGroupParam(dto) {
    return http.post({
      url: '/pc/sysHomeGroupParam/saveHomeGroupParam',
      data: dto
    })
  },

  // 删除分组参数
  delHomeGroupParam(id) {
    return http.post({
      url: '/pc/sysHomeGroupParam/delHomeGroupParam',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取分组参数设备列表
  getHomeGroupParamDeviceList(dto) {
    return http.get({
      url: '/pc/sysHomeGroupParamDevice/getHomeGroupParamDeviceList',
      data: dto
    })
  },

  // 获取分组参数设备
  getHomeGroupParamDevice(dto) {
    return http.get({
      url: '/pc/sysHomeGroupParamDevice/getHomeGroupParamDevice',
      data: dto
    })
  },

  // 保存分组参数设备
  saveHomeGroupParamDevice(dto) {
    return http.post({
      url: '/pc/sysHomeGroupParamDevice/saveHomeGroupParamDevice',
      data: dto
    })
  },

  // 删除分组参数设备
  delHomeGroupParamDevice(id) {
    return http.post({
      url: '/pc/sysHomeGroupParamDevice/delHomeGroupParamDevice',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取分组参数设备实时数据
  getHomeGroupParamDeviceRealDatas(dto) {
    return http.get({
      url: '/pc/sysHomeGroupParam/getHomeGroupParamDeviceRealDatas',
      data: dto
    })
  },

  // 获取分组参数设备视频数据
  getHomeGroupParamDeviceVideoDatas(dto) {
    return http.get({
      url: '/pc/sysHomeGroupParam/getHomeGroupParamDeviceVideoDatas',
      data: dto
    })
  },

  // 获取系统首页分组配置列表
  getSysHomeGroupList(dto) {
    return http.get({
      url: '/pc/index/getSysHomeGroupList',
      data: dto
    })
  },

  // 获取系统首页分组配置
  getSysHomeGroup(dto) {
    return http.get({
      url: '/pc/index/getSysHomeGroup',
      data: dto
    })
  },

  // 保存系统首页分组配置
  saveSysHomeGroup(dto) {
    return http.post({
      url: '/pc/index/saveSysHomeGroup',
      data: dto,
      typea: 1
    })
  },

  // 删除系统首页分组配置
  delSysHomeGroup(id) {
    return http.post({
      url: '/pc/index/delSysHomeGroup',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取分组实时数据（传区域id，一级分组id）
  getNewGreenHouseRealData(dto) {
    return http.get({
      url: '/pc/index/getNewGreenHouseRealData',
      data: dto
    })
  }
}
export default apis
